import { ConfigRecord } from "./ConfigRecord";
import * as GlobalTypes from "../../types";
import { DesiredStateItem } from "./DesiredState";

export type BodyOfWaterUserSettingsRecord = ConfigRecord<BodyOfWaterUserSettingsConfig>;

export type BodyOfWaterUserSettingsConfig = BodyOfWaterUserSettingsConfigItem[];

export class BodyOfWaterUserSettingsConfigItem {
    BodyOfWaterUUID:string;
    Enabled:boolean = true;
    BodyOfWaterUserSettingsByPump:BowUserSettingByPump[] = [];
    BodyOfWaterAutoFillSettings:BowAutofillSettings = new BowAutofillSettings();
};

export class BowUserSettingByPump {
    PumpUUID:GlobalTypes.UUIDV4;
    Enabled:boolean = true;
    CleanFlowSwitchPercent:number = 20;
    DirtyFlowSwitchPercent:number = 60;
    BodyOfWaterUUID:GlobalTypes.UUIDV4;
};

export enum BowAutofillSettingsActions {
    ACTION = "ACTION",
    ALERT_ONLY = "ALERT_ONLY",
}

export enum BowAutofillSettingsItemTypes {
    COMBINED_CONTROL = "COMBINED_CONTROL",
    CONTROL = "CONTROL",
    THEME = "THEME",
    THEME_PLAYLIST = "THEME_PLAYLIST",
}

export class BowAutofillSettings {
    ActionType: BowAutofillSettingsActions;
    AlertAfterMinutes: number = 50;
    BodyOfWaterUUID: GlobalTypes.UUIDV4;
    DelayStartTime: number = 1;
    DesiredState: DesiredStateItem;
    Enabled: boolean = true;
    FillRateInGpm: number = 25;
    ItemType: BowAutofillSettingsItemTypes;
    ItemUUID: GlobalTypes.UUIDV4;
    MaximumDailyRunTimeMinutes: number = 1800;
    MinimumRunMinutes: number;
    WaterLevelSensorUUID: GlobalTypes.UUIDV4;
}